import * as React from 'react';
import { VisualizationSpec } from 'react-vega';

import {
  VoiceboxResponseActionType,
  VoiceboxResponseMessage,
} from 'bones/constants/voicebox/message';

export const useParsedChartSpecFromMessage = (
  message: Pick<VoiceboxResponseMessage, 'actions'>
): { error: boolean; spec: VisualizationSpec | null } =>
  React.useMemo(() => {
    const charts = message.actions?.filter(
      (action) => action.type === VoiceboxResponseActionType.CHART
    );
    if (!charts || !charts.length) {
      return { error: false, spec: null };
    }

    if (charts.length !== 1) {
      console.warn('Got more than 1 chart actions; refusing to show chart', {
        charts,
        message,
      });
      return { error: false, spec: null };
    }

    try {
      const spec = JSON.parse(charts[0].value);
      spec.background = 'transparent';
      return { error: false, spec };
    } catch (err) {
      console.error(err);
      return { error: true, spec: null };
    }
  }, [message]);
